import gql from 'graphql-tag';
import { shipmentListFragment } from '../../../../../../graphql/query/shipmentList';

export default gql`
query shipmentTrackingJd(
  $params: paramsShipmentTrackingJd
  $sort: sort
  $page: Int
  $showData: Int!
){
  shipmentTrackingJd(
  params: $params
  sort: $sort
  page: $page
  showData: $showData
) {
      shipment {
        ...shipmentFields
        completed_date
      }

      total_page
    }
  }

  ${shipmentListFragment}
`;
